module.exports = "https://static.wmbcdn.com/uniweb/images/fcec41a81938bc702091720611871c7d.svg";